import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";

const CreateCompany = () => {
  return (
		<>
			<Helmet>
				<title>Create Gate Entry</title>
			</Helmet>
			<Header />
			<div className="container-fluid maindiv">
				<PurchaseForm />
			</div>
		</>
	);
};

export default CreateCompany;
